import React from 'react';

export default class Scales extends React.Component {
  render() {
    return <div className="content">
      <h3 className="title is-3">Scales</h3>
      <h3 className="subtitle">Retrieve a Scale</h3>
      <p>This section covers how to retrieve a scale by it's id</p>
      <p>Access to scales must be requested on a per scale basis.  If your account is not authorized for a given scale, the response will be a <code>401 Unauthorized</code>.</p>
      <p>To request access to one or more scales, please contact CCI support at <a href="mailto: support@ccihub.com">support@ccihub.com</a>.</p>

      <h3 className="subtitle">HTTP Request</h3>
      <p><code>GET https://api.ccihub.com/api/scales/{`{id}`}</code></p>

      <h3 className="subtitle">Request Parameters</h3>
      <table className="table">
        <thead>
          <th>Parameter</th>
          <th>Required</th>
          <th>Type</th>
          <th>Description</th>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>yes</td>
            <td>number</td>
            <td>The id of the scale to be retrieved</td>
          </tr>
        </tbody>
      </table>

      <h3 className="subtitle">Response Parameters</h3>
      <table className="table">
        <thead>
          <th>Property</th>
          <th>Description</th>
        </thead>
        <tbody>
          <tr>
            <td>scale_id</td>
            <td>The numeric id of the scale</td>
          </tr>
          <tr>
            <td>groups</td>
            <td>An array of group ids and labels</td>
          </tr>
          <tr>
            <td>long_name</td>
            <td>A string representing the full name of the scale</td>
          </tr>
          <tr>
            <td>short_name</td>
            <td>A string representing a short reference name of the scale</td>
          </tr>
          <tr>
            <td>start_question_id</td>
            <td>The id of the first question of the scale</td>
          </tr>
          <tr>
            <td>questions</td>
            <td>An array of question objects with embedded responses</td>
          </tr>
        </tbody>
      </table>

      <h3 className="subtitle">Sample question and response structure</h3>
      <div className="code-snippet">
<pre><code>
{`{
  "_id": {
      "$oid": "557470ea6363696cd0ff0300"
  },
  "field_type": "",
  "gender": null,
  "question_group_id": 0,
  "question_id": "1a",
  "question_text": "Have you been feeling sad or unhappy in the past week?",
  "required": null,
  "responses": [
      {
          "_id": {
              "$oid": "557470ea6363696cd0000400"
          },
          "destination": "1b1",
          "response_text": "Yes",
          "score": null
      },
      {
          "_id": {
              "$oid": "557470ea6363696cd0010400"
          },
          "destination": "1b",
          "response_text": "No",
          "score": null
      }
  ]
}`}
</code></pre>
      </div>

      <h3 className="subtitle">Additional Considerations</h3>
      <p>Some questions are gender specific.  In this event, the <code>gender</code> property will be a string value of "F" for "Female" or "M" for "Male".</p>
      <p>Some responses set a score.  In this event the <code>score</code> will be an integer between 0 and 9.</p>
      <p>Certain scales have optional questions.  For these scales, <code>required</code> will be <code>true</code> or <code>false</code>. If <code>required</code> is <code>null</code>, then it is assumed that a response is required.</p>
      <p>Some responses define a field type. This property is used to determine the type of response control to display to the user.  If <code>null</code>, the responses should be presented as individual radio options or buttons.  The following <code>field_type</code> values are also possible:</p>
      <table className="table">
        <thead>
          <th>field type</th>
          <th>description</th>
        </thead>
        <tbody>
          <tr>
            <td>c</td>
            <td>Checkbox response types</td>
          </tr>
          <tr>
            <td>r</td>
            <td>Actual radio button response types (as opposed to buttons)</td>
          </tr>
          <tr>
            <td>date</td>
            <td>Date response type, a format recognizable by the ISO 8601 standard is required</td>
          </tr>
          <tr>
            <td>number</td>
            <td>Integer response type</td>
          </tr>
        </tbody>
      </table>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/api/Scales.js